export const languageSelector = (state) => state.locale.language;
